(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ParCurvePointController', ParCurvePointController);

    ParCurvePointController.$inject = ['ParCurvePoint'];

    function ParCurvePointController(ParCurvePoint) {

        var vm = this;

        vm.parCurvePoints = [];

        loadAll();

        function loadAll() {
            ParCurvePoint.query(function(result) {
                vm.parCurvePoints = result;
                vm.searchQuery = null;
            });
        }
    }
})();
